import { render, staticRenderFns } from "./FhirPage.vue?vue&type=template&id=a5d46328&scoped=true&"
import script from "./FhirPage.vue?vue&type=script&lang=js&"
export * from "./FhirPage.vue?vue&type=script&lang=js&"
import style0 from "./FhirPage.vue?vue&type=style&index=0&id=a5d46328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d46328",
  null
  
)

export default component.exports